/**
 * 拣选策略域枚举常量定义
 */

// 配置状态
export enum ConfigStatus {
  ENABLED = 'ENABLED',             // 启用
  DISABLED = 'DISABLED',           // 禁用
}

export const ConfigStatusOptions = [
  { value: ConfigStatus.ENABLED, label: 'pickingStrategy.configStatus.enabled', color: 'green' },
  { value: ConfigStatus.DISABLED, label: 'pickingStrategy.configStatus.disabled', color: 'default' },
];

// TMS 通知触发订单状态
export enum TmsNotifyTriggerStatus {
  NOT_STARTED = 'NOT_STARTED',     // 未开始
  IN_PROGRESS = 'IN_PROGRESS',     // 进行中
  COMPLETED = 'COMPLETED',         // 已完成
}

export const TmsNotifyTriggerStatusOptions = [
  { value: TmsNotifyTriggerStatus.NOT_STARTED, label: 'pickingStrategy.tmsNotifyTriggerStatus.notStarted' },
  { value: TmsNotifyTriggerStatus.IN_PROGRESS, label: 'pickingStrategy.tmsNotifyTriggerStatus.inProgress' },
  { value: TmsNotifyTriggerStatus.COMPLETED, label: 'pickingStrategy.tmsNotifyTriggerStatus.completed' },
];
